import { EJsonQueryType, IJsonQueryTerm } from '../../types/jsonQuery/term';

export function createTerm<T>(value: T): IJsonQueryTerm<T> {
  return {
    type: EJsonQueryType.Term,
    value,
  };
}
